export const DataFieldNames = {
  userId: 'data.user.id',
  lastName: 'data.user.lastName',
  firstName: 'data.user.firstName',
  cleanedLastName: 'data.user.cleanedLastName',
  cleanedFirstName: 'data.user.cleanedFirstName',
  externalPatientIds: 'data.user.externalPatientIds',
  birthday: 'data.user.birthday',
  groupId: 'data.group.id',
  prescriptionEndTimestamp: 'data.prescription.endTimestamp',
  lastMeasurement: 'data.lastMeasurement',
  lastMeasurementDate: 'data.lastMeasurement.timestamp',
  lastMeasurementResultColor: 'data.lastMeasurement.mostSevereLabel.color',
  lastMostSevereMeasurementResultColor: 'data.lastMostSevereMeasurement.mostSevereLabel.color',
  lastMostSevereMeasurementDate: 'data.lastMostSevereMeasurement.timestamp',
};
